/**
 * Utilities for working with paths.
 *
 * @module @sorrell/utilities/path
 */
/**
 * @file      index.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
export * from "./Path.ts";
